module.exports = __webpack_public_path__ + "static/Image04@2x-4c483052effcad9aa31b50ce991d6300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image04@2x.jpg
// module id = 897
// module chunks = 227233210825294 244429959259914